// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xImOC","colMin":"styles_colMin__32uNh"};